<template>
  <div class="animated fadeIn">
      <b-row>
         <b-col sm="12" md="12">
            <b-card class="card-accent-info" header="Information personnelle">
                <div class="bd-example">
                  <dl class="row">
                      <dt class="col-sm-2">Nom</dt>
                      <dd class="col-sm-3">{{ mandate.nom }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Prénom(s)</dt>
                      <dd class="col-sm-3">{{ mandate.prenom }}</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Adresse</dt>
                      <dd class="col-sm-3">{{ mandate.adresse }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Téléphone</dt>
                      <dd class="col-sm-3">{{ mandate.telephone }}</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Type de pièce</dt>
                      <dd class="col-sm-3">{{ mandate.piece_libelle }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Type</dt>
                      <dd class="col-sm-3">{{ mandate.num_piece }}</dd>
                  </dl>
                </div>
            </b-card>
            <b-card class="card-accent-info" header="Information sur l'opération">
                <div class="bd-example">
                  <dl class="row">
                      
                      <dt class="col-sm-2">Type opération</dt>
                      <dd class="col-sm-3">{{ mandate.typeoperation_code }}</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Taux commission</dt>
                      <dd class="col-sm-3">{{ mandate.taux_commission }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Commission</dt>
                      <dd class="col-sm-3">{{ mandate.montant_commission }}</dd>
                      
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Montant TVA</dt>
                      <dd class="col-sm-3">{{ mandate.montant_tva }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Montant TTC</dt>
                      <dd class="col-sm-3">{{ mandate.montant_ttc }}</dd>
                  </dl>
                  <dl class="row">
                      <dt class="col-sm-2">Réliquat</dt>
                      <dd class="col-sm-3">{{ mandate.reliquat }}</dd>
                      <dt class="col-sm-1"></dt>
                      <dd class="col-sm-1"></dd>
                      <dt class="col-sm-2">Tarif</dt>
                      <dd class="col-sm-3">{{ mandate.tarif }}</dd>
                  </dl>
                </div>
            </b-card>
          </b-col>
      </b-row>
  </div>
</template>

<script>
export default {
  name: 'tables',
   data(){
    return {
      mandate:{
            adresse: "",
            centre_appel: "",
            date_operation: "",
            deleted_at: "",
            groupage: "",
            guichet_id: "",
            id: "",
            infos_dynamique: "",
            montant_commission: "",
            montant_transfere: "",
            montant_ttc: "",
            montant_tva: "",
            nom: "",
            num_piece: "",
            paiementfile_id: "",
            piece_libelle: "",
            prenom: "",
            reliquat: "",
            tarif: "",
            taux_commission: "",
            taux_tva: "",
            telephone: "",
            typeoperation_code: "",
            updated_at: "",
            user_id: ''
      }
    }
  },
  methods:{
    async displayOperation(){

        let response = await this.$store.dispatch('mandate/get_paiement_by_id',this.$route.params.id)
            console.log("eeee : ",response)
            this.mandate.adresse=response.adresse,
            this.mandate.centre_appel=response.centre_appel,
            this.mandate.date_operation=response.date_operation,
            this.mandate.deleted_at=response.deleted_at,
            this.mandate.groupage=response.groupage,
            this.mandate.guichet_id=response.guichet_id,
            this.mandate.id=response.id,
            this.mandate.infos_dynamique=response.infos_dynamique,
            this.mandate.montant_commission=response.montant_commission,
            this.mandate.montant_transfere=response.montant_transfere,
            this.mandate.montant_ttc=response.montant_ttc,
            this.mandate.montant_tva=response.montant_tva,
            this.mandate.nom=response.nom,
            this.mandate.num_piece=response.num_piece,
            this.mandate.paiementfile_id=response.paiementfile_id,
            this.mandate.piece_libelle=response.piece_libelle,
            this.mandate.prenom=response.prenom,
            this.mandate.reliquat=response.reliquat,
            this.mandate.tarif=response.tarif,
            this.mandate.taux_commission=response.taux_commission,
            this.mandate.taux_tva=response.taux_tva,
            this.mandate.telephone=response.telephone,
            this.mandate.typeoperation_code=response.typeoperation_code,
            this.mandate.updated_at=response.updated_at,
            this.mandate.user_id=response.user_id
        }
    },
    mounted(){
        this.displayOperation()
    }
}
</script>
